type GetTicketMaxQuantityArgs = {
    /** Whether this ticket is a team ticket (only ever one team ticket per checkout). */
    isTeamTicket: boolean;
    /**
     * Whether a team ticket has already been selected this session or is already
     * in the cart, in which case no further team ticket can be added.
     */
    isTeamTicketLimited: boolean;
    /** Remaining stock for a regular (non-team) ticket. */
    stockQuantity: number;
    /**
     * CRM "one ticket per person" flag. When true the ticket is limited to a
     * single purchase per account, so the quantity selector is capped at 1.
     */
    oneTicketPerPerson: boolean;
};

/**
 * Resolves the maximum selectable quantity for a ticket.
 *
 * Regular tickets are bounded by stock; team tickets allow at most one per
 * checkout. The "one ticket per person" flag caps either of those at 1 while
 * still respecting a sold-out (0) state — the server enforces the underlying
 * per-account rule.
 */
const getTicketMaxQuantity = ({
    isTeamTicket,
    isTeamTicketLimited,
    stockQuantity,
    oneTicketPerPerson,
}: GetTicketMaxQuantityArgs): number => {
    const baseMaxQuantity = isTeamTicket
        ? isTeamTicketLimited
            ? 0
            : 1
        : stockQuantity;

    return oneTicketPerPerson
        ? Math.min(baseMaxQuantity, 1)
        : baseMaxQuantity;
};

export default getTicketMaxQuantity;
